import { Component, TemplateRef, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Shared p-editor toolbar markup, exposed as a TemplateRef so consuming
 * `<p-editor>` instances can render it via `ngTemplateOutlet` inside their
 * own required `<ng-template #header>` slot. Holds no form logic or state.
 */
@Component({
  selector: 'app-rich-editor-toolbar',
  imports: [TranslatePipe],
  templateUrl: './rich-editor-toolbar.html',
})
export class RichEditorToolbar {
  template = viewChild.required<TemplateRef<unknown>>('toolbar');

  // Quill format whitelist mirroring the toolbar buttons. Bind to `<p-editor [formats]>`
  // so unsupported formats (color, background, font, size, ...) are stripped on paste.
  readonly formats = ['header', 'bold', 'italic', 'underline', 'list', 'align'];
}
